<template>
  <v-container class="px-0 mx-0 text-center">
    <v-progress-linear indeterminate :active="loading"></v-progress-linear>

    <!-- <span class="grey--text darken-1 text-center" v-if="!loading && statistics.length <= 0">
      Nenhuma consulta agendada
    </span> -->

    <v-row no-glutter dense justify="space-between" align="center" v-if="!loading">
      <v-col xl="3" lg="3" md="3" sm="5" cols="6"
        v-for="(value, name) in statistics" :key="name" align="center">

        <v-hover v-slot:default="{ hover }">
          <v-card class="pa-4 text-center" justify="center" :elevation="hover ? 12 : 2">
              <v-row dense class="pa-0 ma-0">
                <v-col cols="12" class="text-center font-weight-bold title">
                  {{value}}
                </v-col>
                <v-col cols="12" class="text-center"
                  :class="[$vuetify.breakpoint.xsOnly ? 'caption' : 'body-1']">
                  {{labels[name]}}
                </v-col>
              </v-row>
          </v-card>
        </v-hover>

      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import bus from '@/plugins/eventBus';

export default {
  data: () => ({
    loading: false,
    statistics: {
      total: 0,
      totalAttended: 0,
      totalCanceled: 0,
      totalScheduled: 0,
    },
    labels: {
      totalScheduled: 'Agendadas',
      totalAttended: 'Realizadas',
      totalCanceled: 'Canceladas',
      total: 'Total',
    },
  }),
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
    isAuthenticated() {
      return this.$store.getters['auth/isAuthenticated'];
    },
  },
  mounted() {
    this.getStatistics();
  },
  methods: {
    getStatistics() {
      this.loading = true;
      if (this.user && this.isAuthenticated) {
        this.$store
          .dispatch('patientSchedules/getStatistics', this.user.id)
          .then((statistics) => {
            if (statistics) {
              const sttcs = statistics;
              delete sttcs.patientId;
              this.statistics = sttcs;
            }
          })
          .catch((err) => {
            bus.$emit('message', {
              message: err.response.data.message,
              type: 'error',
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
  components: {
  },
};
</script>
